

























import Vue from 'vue';
import { ResourceLoader } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { ExternalClient } from '@/types';
import repository from './external-client-repository';
import ExternalClientItem from './ExternalClientItem.vue';

interface Data {
  externalClients: ExternalClient[],
  name: string,
  task: Promise<ExternalClient[]>|null,
}

export default Vue.extend({
  props: {
    agencyId: {
      type: String,
      required: true,
    },
    value: String,
  },
  data(): Data {
    return {
      externalClients: [],
      name: '',
      task: null,
    };
  },
  computed: {
    filtered(): ExternalClient[] {
      if (this.name === '') return this.externalClients;
      const name = this.name.toLowerCase();
      return this.externalClients.filter(
        ec => (ec.name.toLowerCase().search(name) >= 0),
      );
    },
  },
  watch: {
    agencyId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    clear(): void {
      this.name = '';
    },
    load(): void {
      this.task = repository.findAll(this.agencyId);
      this.task.then((externalClients) => {
        this.externalClients = externalClients;
      });
    },
    removeItem(externalClient: ExternalClient) {
      const index = this.externalClients.findIndex(ec => ec.id === externalClient.id);
      if (index >= 0) {
        this.externalClients.splice(index, 1);
      }
    },
    isGranted,
  },
  components: {
    ResourceLoader,
    ExternalClientItem,
  },
});
